import { pluralize } from '@travelata-libs/utils';
import { RESORT_PLURAL_FORMS } from '@/entities/resort';
import type { Selection } from '@/features/searchForm/destination';

const HOTELS_PLURAL_FROM = ['отель', 'отеля', 'отелей'];

type Options = {
  withCountHotels?: boolean;
};

export function destinationSummary(selection: Selection | null | undefined, options?: Options): string {
  if (!selection || selection.kind === 'none') {
    return '';
  }

  const country = selection.country.name;

  if (selection.kind === 'resorts') {
    if (selection.resorts.length === 1) {
      return `${country}, ${selection.resorts[0].name}`;
    }
    return `${country}, ${pluralize(RESORT_PLURAL_FORMS, selection.resorts.length)}`;
  }

  if (selection.kind === 'hotels') {
    if (selection.hotels.length === 0) {
      return country;
    }
    const hotelsNames = selection.hotels.map((hotel) => hotel.name);
    if (options?.withCountHotels) {
      return `${country}, ${pluralize(HOTELS_PLURAL_FROM, hotelsNames.length)}`;
    }
    return `${country}, ${hotelsNames.join(', ')}`;
  }

  return `${country}, Все курорты`;
}
